import axios from 'axios';
import {
  POPULAR_TRAINS_ENDPOINT_V1,
  STATION_LIST_ENDPOINT_V1,
  TRAINS_LIST_ENDPOINT_V1,
  UPCOMING_JOURNEY_CARDS_ENDPOINT
} from '../constants/LTSConstants';
import { isEmpty } from '../../../utils/isEmpty';
import { getCookie } from './Cookies';

export const getPopularTrainsFromAPI = async () => {
  try {
    const res = await axios.get(POPULAR_TRAINS_ENDPOINT_V1);
    const { Error, popularTrainsList } = res.data;
    if (Error || popularTrainsList?.length === 0) {
      return null;
    } else {
      return popularTrainsList.map(({ popularTrainNo, popularTrainName }) => {
        return {
          trainNumber: popularTrainNo,
          trainName: popularTrainName
        };
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('getPopularTrainsFromAPI() error: ', err);
    return null;
  }
};

export const fetchStationList = async (trainNumber: string) => {
  try {
    const body = {
      trainNumber: `${trainNumber}`,
      trackingParams: {
        affiliateCode: 'MMT001',
        channelCode: 'PWA'
      }
    };
    const res = await axios.post(STATION_LIST_ENDPOINT_V1, body);
    const { Error, Train, Stations } = res.data;
    if (Error || isEmpty(Train) || Stations?.length === 0) {
      return null;
    } else {
      return res.data;
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('fetchStationList() error: ', err);
    return null;
  }
};

export const fetchTrainsList = async (query: string, signal = {} as AbortSignal) => {
  try {
    const config = {
      params: { search_query: query, signal }
    };
    const res = await axios.get(TRAINS_LIST_ENDPOINT_V1, config);
    const { data, success } = res.data;
    if (!success || isEmpty(data)) {
      return null;
    } else {
      return res.data;
    }
  } catch (err: any) {
    if (err?.name === 'AbortError') {
      return {
        msg: err.name
      };
    }
    // eslint-disable-next-line no-console
    console.log('fetchTrainsList() error: ', err);
    return null;
  }
};

export const fetchUpcomingJourneysList = async () => {
  try {
    const uuid = getCookie('mmt-uuid');
    if (isEmpty(uuid)) {
      return null;
    } else {
      const body = {
        uuid: uuid,
        trackingParams: {
          affiliateCode: 'MMT001',
          channelCode: 'PWA'
        }
      };
      const headers = {
        'Content-Type': 'application/json'
      };
      const res = await axios.post(UPCOMING_JOURNEY_CARDS_ENDPOINT, body, { headers });
      const { JourneyCards } = res?.data;
      if (isEmpty(JourneyCards)) {
        return null;
      } else {
        const filteredUpcomingJourneys = (JourneyCards ?? [])?.filter(
          (journey: { Train: { Number: string }; TrainStartDate: string }) => {
            if (
              !isEmpty(journey?.Train?.Number) &&
              !isEmpty(journey?.TrainStartDate) &&
              journey?.TrainStartDate?.split('-').length === 3
            ) {
              return true;
            } else {
              return false;
            }
          }
        );
        return filteredUpcomingJourneys;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('fetchUpcomingJourneysList() error: ', err);
    return null;
  }
};
